import { persistReducer } from "redux-persist";
import { combineReducers } from "redux";
import {
    generalDetailsReducer,
    loginDetailsReducer,
    permissionDetailsReducer,
     visitor_submission_data_reducer, visitor_data_reducer,
} from "./detailsReducer";

import storage from "redux-persist/lib/storage";
import {projectCode} from "../resources/constants";

const rootReducer = combineReducers({
    generalDetails: generalDetailsReducer,
    permissionData: permissionDetailsReducer,
    loginDetails: loginDetailsReducer,
    visitorSubmissionData : visitor_submission_data_reducer,
    visitorData : visitor_data_reducer,
});

const persistConfig = {
    key: projectCode,
    storage,
};

export default persistReducer(persistConfig, rootReducer);